import * as React from 'react';
import UnimplementedView from './UnimplementedView';
function PickerIOS() {
  return /*#__PURE__*/React.createElement(UnimplementedView, null);
}

/**
 * Fallback for other platforms
 */
PickerIOS.Item = UnimplementedView;
export default PickerIOS;
//# sourceMappingURL=PickerIOS.web.js.map